import { QuestionarioStatus } from '../enum/questionario-status.enum';
import { TipoPergunta } from '../enum/tipo-pergunta.enum';
import { TipoQuestionario } from '../enum/tipo-questionario.enum';

export interface QuestionarioAlternativa {
  id?: number;
  texto: string;
  pontos: number;
}

export interface QuestionarioPergunta {
  id?: number;
  texto: string;
  tipo: TipoPergunta;
  // Removido por decisão do PO — peso removido, ver plano
  // 2026-08-11-questionario-erro-exclusao-e-remove-peso.
  // peso: number;
  alternativas: QuestionarioAlternativa[];
}

export interface QuestionarioPerfil {
  idPerfilInvestimento: number;
  nomePerfil: string;
  pontuacaoMinima: number | null;
  pontuacaoMaxima: number | null;
}

export interface QuestionarioFormValue {
  id?: number;
  nome: string;
  tipo: TipoQuestionario;
  /**
   * Status persistido, preenchido só ao carregar um questionário para edição. Não é um campo
   * do formulário: quem define o status ao gravar é a ação escolhida (rascunho ou salvar).
   */
  status?: QuestionarioStatus;
  /** Preenchidos só ao carregar para edição; quando `false` o questionário não pode ser alterado. */
  permiteEdicao?: boolean;
  motivoBloqueioEdicao?: string;
  perguntas: QuestionarioPergunta[];
  perfis: QuestionarioPerfil[];
}

export function createQuestionarioFormDefault(): QuestionarioFormValue {
  return {
    nome: '',
    tipo: TipoQuestionario.Suitability,
    perguntas: [],
    perfis: [],
  };
}
